module.exports = __webpack_public_path__ + "img/GO_02.3006bc5a.png";